import React from 'react';

const Highlight = ({ width, height }) => {
  return (
    <div
      style={{
        ...styles.highlight,
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
};

export default Highlight;

const styles = {
  highlight: {
    backgroundColor: 'transparent',
    opacity: 1,
    position: 'absolute',
    top: 20,
    left: 20,
    border: '1px solid yellow',
    borderRadius: 12,
    zIndex: 1,
  }
};
